<template>
    <div>
        <img class="sizeMarker" src="@/assets/img/pin-red.png" alt="" srcset="">
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>